import React from "react";
import {
  AKT_DAFTAR_JURNAL,
  AKT_JURNAL_UMUM,
  AKT_BUKU_BESAR,
  AKT_LABA_RUGI,
  AKT_LABA_RUGI_DETAIL,
  AKT_MS_TIPE_PENERIMA,
  AKT_MS_PERIODE,
  AKT_MS_TIPE_GL,
  AKT_NERACA_SALDO,
  AKT_NERACA_BULAN,
  AKT_NERACA_BULAN_DETAIL,
  AKT_SYNCHRONIZE,
  AKT_LAP_NERACA,
  AKT_MS_SETTING_NERACA,
  AKT_MS_SETTING_LABA_RUGI,
  AKT_LAP_LABA_RUGI,
  AKT_MASTER_COA,
  AKT_MS_SETTING_CASHFLOW,
  AKT_LAP_CASHFLOW,
  AKT_MS_TARGET_PENDAPATAN,
  AKT_MS_SALDO_AWAL,
  AKT_JURNAL_PENUTUP,
  AKT_LAP_LABA_RUGI_V2,
  AKT_LAP_NERACA_V2,
  AKT_LAP_REKAP_NERACA_V2,
  AKT_LAP_REKAP_LABA_RUGI_V2,
} from "App/constants";

import {
  AkutansiBukuBesarPage,
  AkutansiDaftarJurnalPage,
  AkutansiJurnalUmumPage,
  AkutansiLabaRugiDetailPage,
  AkutansiLabaRugiPage,
  AkutansiLaporanCashFlowPage,
  AkutansiLaporanLabaRugiPage,
  AkutansiLaporanNeracaPage,
  AkutansiNeracaBulanDetailPage,
  AkutansiNeracaBulanPage,
  AkutansiNeracaSaldoPage,
  AkutansiPeriode,
  AkutansiSettingCashFlow,
  AkutansiSettingLabaRugi,
  AkutansiSettingNeraca,
  AkutansiSynchronize,
  AkutansiTargetPendapatan,
  AkutansiTipeGLPage,
  AkutansiTipePenerimaPage,
  MasterCOA,
  AkutansiSaldoAwal,
  AkutansiJurnalPenutup,
  AkutansiLaporanLabaRugiV2Page,
  AkutansiLaporanNeracaV2Page,
  AkutansiLaporanRekapNeracaV2Page,
  AkutansiLaporanRekapLabaRugiV2Page,
} from "./../WrapperLazyExport";

export const menuAkutansi = {
  [AKT_DAFTAR_JURNAL]: <AkutansiDaftarJurnalPage />,
  [AKT_JURNAL_UMUM]: <AkutansiJurnalUmumPage />,
  [AKT_BUKU_BESAR]: <AkutansiBukuBesarPage />,
  [AKT_LABA_RUGI]: <AkutansiLabaRugiPage />,
  [AKT_LABA_RUGI_DETAIL]: <AkutansiLabaRugiDetailPage />,
  [AKT_NERACA_SALDO]: <AkutansiNeracaSaldoPage />,
  [AKT_NERACA_BULAN]: <AkutansiNeracaBulanPage />,
  [AKT_NERACA_BULAN_DETAIL]: <AkutansiNeracaBulanDetailPage />,
  [AKT_MS_TIPE_PENERIMA]: <AkutansiTipePenerimaPage />,
  [AKT_MS_PERIODE]: <AkutansiPeriode />,
  [AKT_MS_TIPE_GL]: <AkutansiTipeGLPage />,
  [AKT_SYNCHRONIZE]: <AkutansiSynchronize />,
  [AKT_LAP_NERACA]: <AkutansiLaporanNeracaPage />,

  [AKT_MS_SETTING_NERACA]: <AkutansiSettingNeraca />,
  [AKT_MS_SETTING_LABA_RUGI]: <AkutansiSettingLabaRugi />,
  [AKT_MS_SETTING_CASHFLOW]: <AkutansiSettingCashFlow />,

  [AKT_LAP_LABA_RUGI]: <AkutansiLaporanLabaRugiPage />,
  [AKT_LAP_LABA_RUGI_V2]: <AkutansiLaporanLabaRugiV2Page />,
  [AKT_LAP_NERACA_V2]: <AkutansiLaporanNeracaV2Page />,
  [AKT_LAP_REKAP_NERACA_V2]: <AkutansiLaporanRekapNeracaV2Page />,
  [AKT_LAP_REKAP_LABA_RUGI_V2]: <AkutansiLaporanRekapLabaRugiV2Page />,
  [AKT_LAP_CASHFLOW]: <AkutansiLaporanCashFlowPage />,
  [AKT_MASTER_COA]: <MasterCOA />,
  [AKT_MS_TARGET_PENDAPATAN]: <AkutansiTargetPendapatan />,
  [AKT_MS_SALDO_AWAL]: <AkutansiSaldoAwal />,
  [AKT_JURNAL_PENUTUP]: <AkutansiJurnalPenutup />,
};
